import * as Actions from '../types/glancer-analytics';
import { createAction } from '../utils';
export const getGlancerDashboardList = () => createAction(Actions.GET_GLANCER_DASHBOARD_LIST);
export const updateGlancerDashboardList = (dashboardList) => createAction(Actions.UPDATE_GLANCER_DASHBOARD_LIST, dashboardList);
export const getGlancerEmbedUrl = (dashboardId) => createAction(Actions.GET_GLANCER_EMBED_URL, dashboardId);
export const updateGlancerEmbedUrl = (embedUrl) => createAction(Actions.UPDATE_GLANCER_EMBED_URL, embedUrl);
